export const ENVIRONMENT = [
  ['production', window.location.origin.includes('capacitor://localhost')],
  ['development', !window.location.origin.includes('capacitor://localhost') && !window.location.origin.includes('contextwriter.ai') && !window.location.origin.includes('contextwriterai.pages.dev')],
  ['staging', window.location.origin.includes('beta.contextwriter.ai')],
  ['production', !window.location.origin.includes('beta.contextwriter.ai') && ( window.location.origin.includes('contextwriter.ai') || window.location.origin.includes('contextwriterai.pages.dev'))]
].find(([name, isActive]) => isActive)[0]

export const CLIENT_HOST = {
   development: `http://localhost:3000`,
   staging: `https://beta.contextwriter.ai`,
   production: `https://contextwriter.ai`
}[ENVIRONMENT]

export const API_HOST = {
  development: 'http://localhost:5005/api/v1',
  staging: 'https://api.sendboth.com/api/v1',
  production: 'https://api.sendboth.com/api/v1'
}[ENVIRONMENT]

export const GOOGLE_ANALYTICS_TRACKING_ID = {
  development: null,
  staging: null,
  production: null
}[ENVIRONMENT]
